import React from 'react';
import { useRouter } from 'next/router';
import { Icon } from 'components/icon/icon';
import { SharesFieldsFragment } from 'api/graphql-types';

import FacebookIcon from 'public/assets/icons/facebook.svg';
import TwitterIcon from 'public/assets/icons/twitter-x.svg';
import WhatsappIcon from 'public/assets/icons/whatsapp.svg';
import PrintIcon from 'public/assets/icons/print.svg';
import LinkedinIcon from 'public/assets/icons/linkedin.svg';

import styles from './share.module.scss';

export type SocialMediaShare_Type = 'Facebook' | 'Twitter' | 'LinkedIn' | 'WhatsApp' | 'Print';

export interface IShareProps {
	module: SharesFieldsFragment;
}
const Share = (props: IShareProps): React.JSX.Element => {
	const { module } = props;
	const { asPath } = useRouter();
	const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

	const pageUrl = `${origin}${asPath}`;

	const allSocials: SocialMediaShare_Type[] = ['Facebook', 'Twitter', 'LinkedIn', 'WhatsApp'];

	return (
		<div className={styles.container}>
			<div className={styles.title}>{module.title.value}</div>

			<span className={styles.iconContainer}>
				{allSocials.map((social) => {
					const socialUrl = getSocialMediaUrl(social, pageUrl || '');

					return social === 'Print' ? (
						<div className={styles.iconWrapper} key={social}>
							<div className={styles.printButton} onClick={() => window.print()}>
								<div className={styles.circleIcon}>
									<div className={styles.icon}>
										<Icon customIcon={getIconForSocial(social)} size="12px" />
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className={styles.iconWrapper} key={social}>
							<a target="_blank" href={socialUrl}>
								<div className={styles.circleIcon}>
									<div className={styles.icon}>
										<Icon customIcon={getIconForSocial(social)} size="12px" />
									</div>
								</div>
							</a>
						</div>
					);
				})}
			</span>
		</div>
	);
};

export default Share;

const getIconForSocial = (type: SocialMediaShare_Type): React.JSX.Element => {
	switch (type) {
		case 'Facebook':
			return <FacebookIcon />;
		case 'Twitter':
			return <TwitterIcon />;
		case 'LinkedIn':
			return <LinkedinIcon />;
		case 'WhatsApp':
			return <WhatsappIcon />;
		case 'Print':
			return <PrintIcon />;

		default:
			return <></>;
	}
};

const getSocialMediaUrl = (type: SocialMediaShare_Type, pageUrl: string): string => {
	switch (type) {
		case 'Facebook':
			return transformSocialMediaPropsToUrl('https://facebook.com/sharer/sharer.php', { u: pageUrl });

		case 'Twitter':
			return transformSocialMediaPropsToUrl('https://twitter.com/intent/tweet/', {
				url: pageUrl
			});

		case 'LinkedIn':
			return transformSocialMediaPropsToUrl('https://www.linkedin.com/sharing/share-offsite', {
				url: pageUrl
			});

		case 'WhatsApp':
			return transformSocialMediaPropsToUrl('whatsapp://send', { text: pageUrl });

		default:
			return '';
	}
};

const transformSocialMediaPropsToUrl = (url: string, params: Record<string, string>): string =>
	`${url}?${new URLSearchParams(params).toString()}`;
